/**
 * FhirLabelsProvider — Injects FHIR resource type → industry terminology mapping.
 *
 * DRR-189: Now powered by resolvedTerminology query (statutory definitions).
 * Previously read from settingBundle.fhirLabels (manually-authored labels).
 *
 * Subgraph packages consume via `useFhirLabel()` from @ferp/subgraph-ui —
 * they don't need Apollo Client access, just the context value.
 *
 * Data flow (DRR-189):
 *   care-vocabulary.yaml tag:def:* → resolvedTerminology query →
 *   useResolvedTerminology() hook → FhirLabelsContext → useFhirLabel()
 */

import type { ReactNode } from 'react';
import { FhirLabelsContext } from '@ferp/subgraph-ui';
import { useResolvedTerminology } from '@/hooks/useResolvedTerminology';

export function FhirLabelsProvider({ children }: { children: ReactNode }) {
  const { getLabel } = useResolvedTerminology();

  return (
    <FhirLabelsContext.Provider value={getLabel}>
      {children}
    </FhirLabelsContext.Provider>
  );
}
